import { useWidget } from "../../../../providers/widget"
import { ExploreWidgetConfig } from "../../config"
import LeafletMap from "./LeafletMap"
import GoogleMap from "./GoogleMap"

// Provider selector: Google Maps when the feed/widget chooses it and a key is
// present, otherwise the default Leaflet/OSM renderer. Each renderer is
// self-contained so only one map SDK loads.
export default function ExplorerMap() {
  const { options } = useWidget<ExploreWidgetConfig>()
  const map = options.map
  const useGoogle = map?.provider === 'google' && !!map?.apiKey?.trim()
  return useGoogle ? <GoogleMap /> : <LeafletMap />
}
